import { GridComponent } from '@syncfusion/ej2-react-grids';
import {
  DialogComponent,
  AnimationSettingsModel,
  ButtonPropsModel,
} from '@syncfusion/ej2-react-popups';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import * as React from 'react';
import { FaCopy, FaMinus, FaPlus } from 'react-icons/fa';
import { IconContext } from 'react-icons/lib';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { ThemeContext } from '../../../context/theme.context';
import { all_information, loadingShow } from '../../../App';
import { toast } from 'react-toastify';
import './style.css';
import { SwitchComponent } from '@syncfusion/ej2-react-buttons';
import {
  AddShiftWorkbenchTemplate,
  DeleteShiftWorkbenchTemplate,
  EditShiftWorkbenchTemplate,
  getShiftWorkbenchTemplate,
} from '../../../services/ShiftWorkbench/ShitWorkbenchTemplateService';
import Message from '../../../utils/Message/Message';
import AssetsIntelligenceServices from '../../../services/AssetsIntelligence/AssetsIntelligenceServices';
import { getusers } from '../../../services/Users/Users';
import { getShiftWorkbenchSubStuff } from '../../../services/ShiftWorkbench/ShiftWorkbenchSubStuff';
import { getShiftWorkbenchSettings } from '../../../services/ShiftWorkbench/ShitWorkbenchSettingsServices';
import { getComponentS } from '../../../services/Components/ComponentServices';
import { AddShiftWorkbench } from '../../../services/ShiftWorkbench/ShiftWorkbenchService';
import GlobalGrid from '../../../components/GlobalGrid';
import { wTemplateColumns } from './WorkbenchTemplateColumns';
import {
  getTeamAssigments,
  getTeams,
} from '../../../services/tradeperson/team';
interface IProps {
  apply_defaul_button?: any;
  apply_template?: any;
  isWorkbench?: boolean;
}
interface IState {
  hideDialog: boolean;
  rowCount: number;
  assignment: Array<any>;
  list: Array<JSX.Element>;
  dayGrid: Array<any>;
  minus: boolean;
  plus: boolean;
  fieldSet: any;
  isEnableCopy: boolean;
  editDialog: boolean;
  hideDialogDelete: boolean;
  pickedTemplateId: any;
  team_data: any;
  asset_type_data: any;
  asset_data: any;
  user_data: Array<any>;
  targetData: Array<any>;
  mareaData: Array<any>;
  sourceData: Array<any>;
  mTypeData: Array<any>;
  tab_number: number;
  component_data: Array<any>;
  EquipmentData: Array<any>;
  hideDialogIsAdded: boolean;
  ProductionMovementsData: Array<any>;
  dialogRowData: Array<any>;
}
export default class WorkbenchTemplate extends React.Component<IProps, IState> {
  static contextType = ThemeContext;
  context!: React.ContextType<typeof ThemeContext>;
  private template_data: Array<any> = [];
  public toolbarOptions: any = [
    {
      text: 'Add',
      tooltipText: 'Add',
      prefixIcon: 'e-add',
      id: 'add',
    },
    {
      text: 'Edit',
      tooltipText: 'Edit',
      prefixIcon: 'e-edit',
      id: 'edit',
    },
    {
      text: 'Delete',
      tooltipText: 'Delete',
      prefixIcon: 'e-delete',
      id: 'delete',
    },
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-repeat',
      id: 'refresh',
    },
    this.props.isWorkbench
      ? {
          text: 'Add Selected Template',
          tooltipText: 'Apply Default Template',
          prefixIcon: 'e-add',
          id: 'add-template',
        }
      : '',
    this.props.isWorkbench
      ? {
          text: 'Apply Default Template',
          tooltipText: 'Apply Default Template',
          prefixIcon: 'e-save',
          id: 'apply-template',
        }
      : '',
    'ExcelExport',
    'ColumnChooser',
    'Search',
  ];
  private grid: any;
  private buttons: ButtonPropsModel[];
  private buttonsIsAddedEquipment: ButtonPropsModel[];
  private animationSettings: AnimationSettingsModel;
  private list: Array<JSX.Element>;
  private actionData: Array<any>;
  private tempActionData: Array<any>;
  private name: string;
  private module_name: string = '';
  private template_code: string = '';
  private whereQuery: string = '';
  private isDefault: boolean = false;
  private isShare: boolean = false;
  private buttonsDelete: ButtonPropsModel[];
  private pickedTemplateId: Number = 0;
  private assetsServicess = new AssetsIntelligenceServices();
  private team_value: number = -1;
  private user_value: number = -1;
  private tab_name: string = 'Equipment Summary';
  private module_id: number = -1;
  private ddObj: DropDownListComponent;
  private created_date = new Date();
  private workbench_id = -1;
  private TemplateData: any = [];
  private is_override = false;
  private is_equipment = true;
  private isItFirstTime = true;
  private isEdit: boolean = false;
  private tabNameData = [
    {
      name: 'Equipment Summary',
      value: 0,
    },
    {
      name: 'Production Movements',
      value: 1,
    },
  ];
  private allowRefresh: boolean = true;
  constructor(props: {}) {
    super(props);
    this.grid = new GridComponent(props);
    this.animationSettings = { effect: 'Zoom', duration: 400, delay: 0 };
    this.buttonsDelete = [
      {
        click: () => {
          this.deleteTemplate();
        },
        buttonModel: {
          content: 'Yes',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideDialogDelete: false });
        },
        buttonModel: {
          content: 'No',
        },
      },
    ];
    this.buttons = [
      {
        click: () => {
          this.saveTemplate();
        },
        buttonModel: {
          content: 'Save',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideDialog: false });
        },
        buttonModel: {
          content: 'Cancel',
        },
      },
    ];
    this.buttonsIsAddedEquipment = [
      {
        click: () => {
          this.is_override = false;
          if (this.is_equipment) this.SavePointTemplateEquipment();
          else this.SavePointTemplateMovements();
        },
        buttonModel: {
          content: 'Append',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.is_override = true;
          if (this.is_equipment) this.SavePointTemplateEquipment();
          else this.SavePointTemplateMovements();
        },
        buttonModel: {
          content: 'Override',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideDialogIsAdded: false });
        },
        buttonModel: {
          content: 'Cancel',
        },
      },
    ];
    this.state = {
      pickedTemplateId: '',
      hideDialogDelete: false,
      hideDialog: false,
      rowCount: 10,
      assignment: [],
      list: [],
      dayGrid: [
        {
          order: 1,
        },
        {
          order: 2,
        },
      ],
      plus: false,
      minus: false,
      fieldSet: [
        ['Asset Type', 'Asset Number', 'Operator'],
        [
          'Truck',
          'Excavator',
          'Mining Area',
          'Movement Type',
          'Source Location',
          'Target Location',
          'Operator',
        ],
      ],
      isEnableCopy: false,
      editDialog: false,
      team_data: [],
      asset_type_data: [],
      asset_data: [],
      user_data: [],
      mareaData: [],
      mTypeData: [],
      sourceData: [],
      targetData: [],
      tab_number: 0,
      component_data: [],
      EquipmentData: [],
      ProductionMovementsData: [],
      hideDialogIsAdded: false,
      dialogRowData: [],
    };
    this.actionData = [];
    this.tempActionData = [];
    this.list = [];
    this.name = '';
    this.ddObj = new DropDownListComponent(props);
  }
  getUsers() {
    getusers()
      .then((el) => {
        this.setState({
          user_data: el.data.map((el: any) => {
            return { ...el, name: el.first_name + ' ' + el.last_name };
          }),
        });
      })
      .catch((error) => {
        if (error.response) {
          Message.error(error.response.data);
          Message.error(error.response.status);
          Message.error(error.response.headers);
        } else if (error.request) {
          Message.error(error.request);
        } else {
          Message.error('Error: ' + error.message);
        }
        Message.error(error.config);
      });
  }

  getTeams() {
    getTeams()
      .then((res) => {
        this.setState({ team_data: res.data });
      })
      .catch((error) => {
        if (error.response) {
          Message.error(error.response.data);
          Message.error(error.response.status);
          Message.error(error.response.headers);
        } else if (error.request) {
          Message.error(error.request);
        } else {
          Message.error('Error: ' + error.message);
        }
        Message.error(error.config);
      });
  }
  getAsset(filterCase: string) {
    this.assetsServicess
      .getAssets(filterCase)
      .then((res) => {
        this.setState({ asset_data: res.data });
      })
      .catch((error) => {
        if (error.response) {
          Message.error(error.response.data);
          Message.error(error.response.status);
          Message.error(error.response.headers);
        } else if (error.request) {
          Message.error(error.request);
        } else {
          Message.error('Error: ' + error.message);
        }
        Message.error(error.config);
      });
  }
  getAssetType() {
    getShiftWorkbenchSettings('assettype')
      .then((res) => {
        this.setState({
          asset_type_data: res.data.map((el: any) => {
            return { ...el, asset_code: el.asset_code + '-' + el.description };
          }),
        });
      })
      .catch((error) => {
        if (error.response) {
          Message.error(error.response.data);
          Message.error(error.response.status);
          Message.error(error.response.headers);
        } else if (error.request) {
          Message.error(error.request);
        } else {
          Message.error('Error: ' + error.message);
        }
        Message.error(error.config);
      });
  }
  saveTemplate = () => {
    if (this.name === '') {
      Message.error('Template name cant be empty');
      return;
    }
    if (this.template_code === '') {
      Message.error('Template code cant be empty');
      return;
    }
    var obj: any = {
      id: this.pickedTemplateId,
      user_id: all_information.user_id,
      app: 'UWORK',
      organization_id: all_information.company_id?.toString(),
      name: this.name,
      isDefault: this.isDefault,
      isShared: this.isShare,
      team_id: this.team_value,
      team_code: $('#ddTeamPicker').val(),
      user_name_id: this.user_value,
      user_name: $('#userDDpicker').val(),
      template_code: this.template_code,
      template_module: this.module_name,
      tab_name: this.tab_name,
      shiftWTemplateDetail: [...this.actionData],
    };
    loadingShow(true, 'Saving');
    if (this.isEdit) {
      EditShiftWorkbenchTemplate(obj)
        .then((response) => {
          loadingShow(false, 'Saving');
          toast.success('Save is success');
          this.actionData = [];
          this.setState({ hideDialog: false });
          this.getWorkbenchTemplateemplate();
        })
        .catch((error) => {
          loadingShow(false, 'Saving');
          if (error.response) {
            Message.error(error.response.data);
            Message.error(error.response.status);
            Message.error(error.response.headers);
          } else if (error.request) {
            Message.error(error.request);
          } else {
            Message.error('Error: ' + error.message);
          }
          Message.error(error.config);
        });
    } else {
      delete obj.id;
      AddShiftWorkbenchTemplate(obj)
        .then((response) => {
          loadingShow(false, 'Saving');
          this.actionData = [];
          this.setState({ hideDialog: false, rowCount: 4 });
          this.getWorkbenchTemplateemplate();
          toast.success('Save is success');
        })
        .catch((error) => {
          loadingShow(false, 'Saving');
          if (error.response) {
            Message.error(error.response.data);
            Message.error(error.response.status);
            Message.error(error.response.headers);
          } else if (error.request) {
            Message.error(error.request);
          } else {
            Message.error('Error: ' + error.message);
          }
          Message.error(error.config);
        });
    }
  };
  async getWorkbenchEquipmentSummary(query: string) {
    await getShiftWorkbenchSubStuff(query).then((res) => {
      this.setState({ EquipmentData: res.data });
    });
  }

  async componentDidMount() {
    this.getTeams();
    this.getAssetType();
    this.getAsset('');
    this.getUsers();
    this.getMType();
    this.getComponent();
    this.getMarea();
    this.getSource();
    this.getTarget();
    this.getWorkbenchEquipmentSummary(`eqsum$${this.workbench_id}`);
  }
  componentDidUpdate(
    prevProps: Readonly<IProps>,
    prevState: Readonly<IState>,
    snapshot?: any
  ) {
    if (
      prevState.tab_number !== this.state.tab_number ||
      (prevState.assignment !== this.state.assignment && this.allowRefresh) ||
      (prevState.hideDialog !== this.state.hideDialog &&
        this.state.hideDialog) ||
      prevState.rowCount !== this.state.rowCount
    ) {
      this.setState({ dialogRowData: this.renderRow() });
      this.setState({ hideDialog: true });
    }
    if (this.context.isDataChangeWorkbenchBottomData) {
      var response = this.context.workbenchValueBottom.split(',');
      this.workbench_id = parseInt(response[1]);
      this.created_date = new Date(response[0]);
      this.whereQuery = response[2];
      if (this.whereQuery === 'Equipment Summary') {
        this.is_equipment = true;
      } else {
        this.is_equipment = false;
      }
      this.getWorkbenchTemplateemplate();
      this.getWorkbenchEquipmentSummary(`eqsum$${this.workbench_id}`);
      this.context.setDataChangeWorkbenchBottomData(
        false,
        this.context.workbenchValueBottom
      );
    }
  }
  deleteTemplate() {
    var templateID = this.pickedTemplateId;
    if (templateID === 0) {
      toast.error('Item was not selected be empty');
      loadingShow(false);
      return false;
    }
    let obj = {
      id: Number(templateID),
      shiftWTemplateDetail: [...this.actionData],
    };
    loadingShow(true, 'Deleting...');
    DeleteShiftWorkbenchTemplate(obj)
      .then((response) => {
        loadingShow(false, 'Saving');
        toast.success('Delete is success');
        this.actionData = [];
        this.setState({ hideDialogDelete: false, rowCount: 4 });
        this.getWorkbenchTemplateemplate();
      })
      .catch((e) => {
        loadingShow(false, 'Saving');
        toast.error('Error occured. Try again later');
      });
  }

  dialogOpenDelete(): void {
    this.setState({ hideDialogDelete: true });
  }
  dialogCloseDelete(): void {
    this.setState({
      hideDialogDelete: false,
    });
  }
  getWorkbenchTemplateemplate() {
    getShiftWorkbenchTemplate().then((result) => {
      if (!this.isItFirstTime) {
        if (this.grid.dataSource) {
          this.grid.dataSource = result.data;
        }
      }
    });
  }

  dialogClose(): void {
    this.setState({ hideDialog: false });
  }
  dialogOpen(): void {}
  begin(args: any) {
    if (args.requestType === 'beginEdit') {
      alert('edit');
    }
    if (args.requestType === 'save') {
      alert('save');
    }
  }
  async toolbarClick(args: any) {
    if (args.item.id === 'add') {
      this.isEdit = false;
      this.setState({ hideDialog: true });
    }
    if (args.item.id === 'delete') {
      var selectedData = this.grid.getSelectedRecords();
      this.pickedTemplateId = Number(selectedData[0].id);
      this.dialogOpenDelete();
    }
    if (args.item.id === 'edit') {
      if (this.grid.getSelectedRecords().length !== 0) {
        this.isEdit = true;
        var selectedData = this.grid.getSelectedRecords();
        this.name = selectedData[0].name;
        this.template_code = selectedData[0].template_code;
        this.module_name = selectedData[0].template_module;
        this.tab_name = selectedData[0].tab_name;
        this.team_value = selectedData[0].team_id;
        this.user_value = Number(selectedData[0].user_id);
        this.pickedTemplateId = selectedData[0].id;
        this.allowRefresh = false;
        await this.getTeamAssignment(this.team_value);
        this.allowRefresh = true;
        this.actionData = selectedData[0].shiftWTemplateDetail;
        this.isDefault = selectedData[0].isDefault;
        this.isShare = selectedData[0].isShared;
        let tab_name_index = this.tabNameData.findIndex((el) => {
          return el.name === this.tab_name;
        });
        this.setState({
          hideDialog: true,
          rowCount: selectedData[0].shiftWTemplateDetail.length,
          tab_number: tab_name_index,
        });
      } else {
        alert('no records selected for edited operation');
      }
    }
    if (args.item.id === 'add-template') {
      if (this.workbench_id === -1) {
        Message.error('Please select a tab first!');
        return false;
      }
      if (this.grid.getSelectedRecords().length > 0) {
        let data = this.grid.getSelectedRecords()[0];
        this.TemplateData = data;
        if (this.whereQuery === 'Equipment Summary') {
          await this.getWorkbenchEquipmentSummary(`eqsum$${this.workbench_id}`);
          let findTemplate = this.state.EquipmentData.find(
            (x: any) => x.template_id === data.id
          );
          if (findTemplate !== undefined)
            this.setState({ hideDialogIsAdded: true });
          else this.SavePointTemplateEquipment();
        } else {
          let findTemplate = this.state.ProductionMovementsData.find(
            (x: any) => x.template_id === data.id
          );
          if (findTemplate !== undefined)
            this.setState({ hideDialogIsAdded: true });
          else this.SavePointTemplateMovements();
        }
      } else {
        Message.error('Please select a records!');
        return false;
      }
    }
    if (args.item.id === 'apply-template') {
      if (this.workbench_id === -1) {
        Message.error('Please select a tab first');
        return false;
      }
      let findTemplate = this.template_data.find(
        (x: any) => x.isDefault === true
      );

      if (findTemplate !== undefined) {
        this.TemplateData = findTemplate;
        if (this.whereQuery === 'Equipment Summary') {
          await this.getWorkbenchEquipmentSummary(`eqsum$${this.workbench_id}`);
          let findData = this.state.EquipmentData.find(
            (x: any) => x.template_id === findTemplate.id
          );
          if (findData !== undefined)
            this.setState({ hideDialogIsAdded: true });
          else this.SavePointTemplateEquipment();
        } else {
          let findData = this.state.ProductionMovementsData.find(
            (x: any) => x.template_id === findTemplate.id
          );
          if (findData !== undefined)
            this.setState({ hideDialogIsAdded: true });
          else this.SavePointTemplateMovements();
        }
      } else {
        Message.error('Default template not found!');
      }
    }
  }
  async SavePointTemplateEquipment() {
    let data = this.TemplateData;
    let obj = data.shiftWTemplateDetail.map((item: any) => {
      return {
        app: 'app',
        organization_id: all_information.company_id?.toString(),
        workbench_id: this.workbench_id,
        date: this.created_date,
        template_id: data.id,
        user_id: all_information.user_id,
        is_override: this.is_override,
        asset_type_id: item.asset_id,
        operator_: item.assignment_code,
        asset_number: item.asset_number,
        unit: 'eqsum',
      };
    });
    loadingShow(true);
    await AddShiftWorkbench(obj)
      .then((res) => {
        Message.success('Success');
        this.getWorkbenchEquipmentSummary(`eqsum$${this.workbench_id}`);
        this.setState({ hideDialogIsAdded: false });
        this.context.setChangeTabForTemplateWB(true, 0);
        this.context.setDataChangeForTemplateWBData(true);
        loadingShow(false);
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  }
  async SavePointTemplateMovements() {
    let data = this.TemplateData;
    let obj = {
      app: 'app',
      organization_id: all_information.company_id?.toString(),
      workbench_id: this.workbench_id,
      date: new Date(this.created_date),
      template_id: data.id,
      user_id: all_information.user_id,
      type: 'movements',
      is_override: this.is_override,
      ...data.shiftWTemplateDetail.map((item: any) => {
        return {
          ...item,
          operator_name: item.assignment_code,
          operator_id: item.assignment_id,
        };
      }),
    };
    //(obj);
    loadingShow(true);
    AddShiftWorkbench(obj)
      .then((res) => {
        Message.success('Success');
        this.setState({ hideDialogIsAdded: false });
        this.context.setChangeTabForTemplateWB(true, 1);
        this.context.setDataChangeForTemplateWBData(true);
        loadingShow(false);
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  }
  Onchange(args: any) {
    let condMin;
    let condPlus;
    let disableCoppy;
    if (args.value === 1) {
      condMin = true;
      condPlus = false;
      disableCoppy = false;
    }
    if (args.value === 4) {
      condPlus = true;
      condMin = false;
      disableCoppy = true;
    }
    if (args.value !== 1 && args.value !== 4) {
      condMin = false;
      condPlus = false;
      disableCoppy = false;
    }
    this.setState({
      rowCount: args.value,
      minus: condMin as boolean,
      plus: condPlus as boolean,
      isEnableCopy: disableCoppy as boolean,
      hideDialog: false,
    });
  }
  changeDrop(direction: number, row_index: number, e: any) {
    const incomming = e.target.id;
    const currentData = e.value;
    const current_Text = e.target.typedString;
    if (direction === 1) {
      this.actionData[row_index].asset_id = currentData;
      this.actionData[row_index].asset_code = current_Text;
    } else if (direction === 2) {
      this.actionData[row_index].assignment_id = currentData;
      this.actionData[row_index].assignment_code = current_Text;
    } else if (direction === 3) {
      this.actionData[row_index].asset_number = current_Text;
      this.actionData[row_index].asset_number_id = currentData;
    } else if (direction === 4) {
      this.actionData[row_index].truck = currentData;
    } else if (direction === 5) {
      this.actionData[row_index].excavator = currentData;
    } else if (direction === 6) {
      this.actionData[row_index].m_area = current_Text;
      this.actionData[row_index].m_area_id = currentData;
    } else if (direction === 7) {
      this.actionData[row_index].m_type = current_Text;
      this.actionData[row_index].m_type_id = currentData;
    } else if (direction === 8) {
      this.actionData[row_index].s_location = current_Text;
      this.actionData[row_index].s_location_id = currentData;
    } else if (direction === 9) {
      this.actionData[row_index].t_location = current_Text;
      this.actionData[row_index].t_location_id = currentData;
    }
  }
  copyLine(row: number) {
    const targetIndex = Number(this.state.rowCount) + 1;
    var theCounter = 0;
    if (this.actionData.length != 0) {
      for (var i = 1; i <= targetIndex; i++) {
        this.actionData[theCounter] !== undefined
          ? this.tempActionData.push(this.actionData[theCounter])
          : this.tempActionData.push({
              item_sequence: i?.toString(),
              asset_id: 0,
              asset_code: '',
              assignment_code: '',
              assignment_id: 0,
              asset_number: '',
            });
        theCounter++;
      }
      theCounter = 0;
      this.actionData = [];
      this.actionData.push(...this.tempActionData);
      this.tempActionData = [];
    } else {
      for (var k = 1; k <= targetIndex; k++) {
        const theNum = k;
        const theObj = {
          item_sequence: theNum?.toString(),
          asset_id: 0,
          asset_code: '',
          assignment_code: '',
          asset_number: '',
          assignment_id: 0,
        };
        this.actionData.push(theObj);
      }
    }
    const startFromCopyIndex = row - 1;
    const startToCopyIndex = targetIndex - 1;
    this.actionData[startToCopyIndex] = {
      ...this.actionData[startFromCopyIndex],
      item_sequence:
        this.actionData[startToCopyIndex].item_sequence?.toString(),
    };
    let isCopyDisable = false;
    this.setState({
      rowCount: targetIndex,
      isEnableCopy: isCopyDisable,
      minus: false,
    });
  }
  async getTeamAssignment(teamID: number) {
    await getTeamAssigments(teamID).then((res) => {
      if (res.data.length > 0)
        this.setState({ assignment: res.data, hideDialog: false });
    });
  }
  onFilter(args: any) {
    if (args.name === 'filtering') {
      args.cancel = true;
      // this.getAsset(args.text);
      // var theDD = $(`#${id}`) as unknown as DropDownListComponent;
      // var theTest = id.dataSource;
      // theTest = [];
      // //(theTest);
    }
  }
  getTarget() {
    getShiftWorkbenchSettings('targetlocation')
      .then((el) => {
        this.setState({ targetData: el.data });
      })
      .catch((e) => {
        //(e);
      });
  }
  getMarea() {
    getShiftWorkbenchSettings('marea')
      .then((el) => {
        this.setState({ mareaData: el.data });
      })
      .catch((e) => {
        //(e);
      });
  }
  getMType() {
    getShiftWorkbenchSettings('movementstype')
      .then((el) => {
        this.setState({ mTypeData: el.data });
      })
      .catch((e) => {
        //(e);
      });
  }
  getSource() {
    getShiftWorkbenchSettings('sourcelocation')
      .then((el) => {
        this.setState({ sourceData: el.data });
      })
      .catch((e) => {
        //(e);
      });
  }
  getComponent() {
    getComponentS().then((result: any) => {
      this.setState({ component_data: result.data });
    });
  }
  rowTemplateEquipmentSummary(rowData: any, row: number) {
    return (
      <tr
        style={{
          backgroundColor: this.context.isDarkMode ? '#15202B' : 'white',
          color: 'white',
        }}
      >
        <td
          style={{
            backgroundColor: this.context.isDarkMode ? '#15202B' : 'white',
            color: 'white',
          }}
        >
          {row}
        </td>
        <td>
          {' '}
          <DropDownListComponent
            id={'' + row + '1'}
            dataSource={this.state.asset_type_data}
            onChange={this.changeDrop.bind(this, 1, row - 1)}
            fields={{ text: 'asset_code', value: 'id' }}
            value={rowData.asset_id}
            width={'170px'}
          />{' '}
        </td>
        <td>
          {' '}
          <DropDownListComponent
            id={'' + row + '2'}
            onChange={this.changeDrop.bind(this, 3, row - 1)}
            filterType={'Contains'}
            allowFiltering
            dataSource={this.state.asset_data}
            fields={{ value: 'assetId', text: 'asset_code' }}
            text={rowData.asset_number}
            actionBegin={(args) => {
              // //(args);
            }}
            value={61}
            width={'170px'}
            filtering={this.onFilter.bind(this)}
          />{' '}
        </td>
        <td>
          {' '}
          <DropDownListComponent
            id={'' + row + '2'}
            dataSource={this.state.assignment}
            onChange={this.changeDrop.bind(this, 2, row - 1)}
            fields={{ text: 'alias_name', value: 'assignment_id' }}
            value={rowData.assignment_id}
            width={'170px'}
          />{' '}
        </td>

        <td>
          {' '}
          <button
            className='copyButton'
            style={{ backgroundColor: 'transparent', border: 'none' }}
            onClick={this.copyLine.bind(this, row)}
            disabled={this.state.isEnableCopy}
          >
            <IconContext.Provider
              value={{
                color: this.context.isDarkMode
                  ? this.state.isEnableCopy
                    ? '#a39e9e'
                    : '#fcfafa'
                  : this.state.isEnableCopy
                  ? '#a39e9e'
                  : '#686968',
              }}
            >
              <FaCopy className='' />
            </IconContext.Provider>
          </button>{' '}
        </td>
      </tr>
    );
  }
  rowTemplateMovements(rowData: any, row: number) {
    return (
      <tr
        style={{
          backgroundColor: this.context.isDarkMode ? '#15202B' : 'white',
          color: 'white',
        }}
      >
        <td
          style={{
            backgroundColor: this.context.isDarkMode ? '#15202B' : 'white',
            color: 'white',
          }}
        >
          {row}
        </td>
        <td>
          {' '}
          <TextBoxComponent
            id={'' + row + '1'}
            onChange={this.changeDrop.bind(this, 4, row - 1)}
            value={rowData.truck}
            width={'150px'}
          />{' '}
        </td>
        <td>
          {' '}
          <TextBoxComponent
            id={'' + row + '1'}
            onChange={this.changeDrop.bind(this, 5, row - 1)}
            value={rowData.excavator}
            width={'150px'}
          />{' '}
        </td>
        <td>
          {' '}
          <DropDownListComponent
            id={'' + row + '1'}
            dataSource={this.state.mareaData}
            onChange={this.changeDrop.bind(this, 6, row - 1)}
            fields={{ text: 'area_code', value: 'id' }}
            value={rowData.m_area_id}
            text={rowData.m_area}
            width={'150px'}
          />{' '}
        </td>
        <td>
          {' '}
          <DropDownListComponent
            id={'' + row + '2'}
            onChange={this.changeDrop.bind(this, 7, row - 1)}
            dataSource={this.state.mTypeData}
            fields={{ text: 'm_type_code', value: 'id' }}
            text={rowData.m_type}
            value={rowData.m_type_id}
            width={'150px'}
            filtering={this.onFilter.bind(this)}
          />{' '}
        </td>
        <td>
          {' '}
          <DropDownListComponent
            id={'' + row + '2'}
            onChange={this.changeDrop.bind(this, 8, row - 1)}
            dataSource={this.state.sourceData}
            fields={{ text: 's_location_code', value: 'id' }}
            text={rowData.s_location}
            value={rowData.s_location_id}
            width={'150px'}
            filtering={this.onFilter.bind(this)}
          />{' '}
        </td>
        <td>
          {' '}
          <DropDownListComponent
            id={'' + row + '2'}
            onChange={this.changeDrop.bind(this, 9, row - 1)}
            dataSource={this.state.targetData}
            fields={{ text: 't_location_code', value: 'id' }}
            text={rowData.t_location}
            value={rowData.t_location_id}
            width={'150px'}
            filtering={this.onFilter.bind(this)}
          />{' '}
        </td>
        <td>
          {' '}
          <DropDownListComponent
            id={'' + row + '2'}
            dataSource={this.state.assignment}
            onChange={this.changeDrop.bind(this, 2, row - 1)}
            fields={{ text: 'alias_name', value: 'assignment_id' }}
            value={rowData.assignment_id?.toString()}
            width={'150px'}
          />{' '}
        </td>

        <td>
          {' '}
          <button
            className='copyButton'
            style={{ backgroundColor: 'transparent', border: 'none' }}
            onClick={this.copyLine.bind(this, row)}
            disabled={this.state.isEnableCopy}
          >
            <IconContext.Provider
              value={{
                color: this.context.isDarkMode
                  ? this.state.isEnableCopy
                    ? '#a39e9e'
                    : '#fcfafa'
                  : this.state.isEnableCopy
                  ? '#a39e9e'
                  : '#686968',
              }}
            >
              <FaCopy className='' />
            </IconContext.Provider>
          </button>{' '}
        </td>
      </tr>
    );
  }
  tableHeaderManagement(index: number) {
    const myStyle = {
      backgroundColor: this.context.isDarkMode ? '#15202B' : 'white',
      color: this.context.isDarkMode ? 'white' : '#15202B',
    };
    return (
      <tr>
        <td style={myStyle}>#</td>
        {this.state.fieldSet[index].map((e2: any, i2: any) => {
          return <td style={myStyle}>{e2}</td>;
        })}
      </tr>
    );
  }
  renderRow = () => {
    this.list = [];
    var theCounter = 0;
    if (this.actionData.length != 0) {
      for (var i = 1; i <= this.state.rowCount; i++) {
        this.actionData[theCounter] !== undefined
          ? this.tempActionData.push(this.actionData[theCounter])
          : this.tempActionData.push({
              item_sequence: i?.toString(),
              asset_id: 0,
              asset_code: '',
              assignment_code: '',
              assignment_id: 0,
              asset_number: '',
              asset_number_id: 0,
              m_type: '',
              m_type_id: 0,
              m_area: '',
              m_area_id: 0,
              t_location: '',
              t_location_id: 0,
              s_location: '',
              s_location_id: 0,
              excavator: '',
              truck: '',
            });
        theCounter++;
      }
      theCounter = 0;
      this.actionData = [];
      this.actionData.push(...this.tempActionData);
      this.tempActionData = [];
    } else {
      for (var i = 1; i <= this.state.rowCount; i++) {
        const theNum = i;
        const theObj = {
          item_sequence: theNum?.toString(),
          asset_id: 0,
          asset_code: '',
          assignment_code: '',
          assignment_id: 0,
          asset_number: '',
          asset_number_id: 0,
          m_type: '',
          m_type_id: 0,
          m_area: '',
          m_area_id: 0,
          t_location: '',
          t_location_id: 0,
          s_location: '',
          s_location_id: 0,
          excavator: '',
          truck: '',
        };
        this.actionData.push(theObj);
      }
    }
    this.list.push(this.tableHeaderManagement(this.state.tab_number));
    if (this.state.tab_number === 0) {
      for (var i = 1; i <= this.state.rowCount; i++) {
        this.list.push(
          this.rowTemplateEquipmentSummary(this.actionData[i - 1], i)
        );
      }
    } else if (this.state.tab_number === 1) {
      for (var i = 1; i <= this.state.rowCount; i++) {
        this.list.push(this.rowTemplateMovements(this.actionData[i - 1], i));
      }
    }
    return this.list;
  };

  increase() {
    var temp = this.state.rowCount;
    this.setState({ rowCount: ++temp, minus: false });
  }
  decrease() {
    var temp = this.state.rowCount;
    if (this.state.rowCount <= 2) {
      this.setState({ minus: true, plus: false, rowCount: --temp });
    } else {
      this.setState({ rowCount: --temp, plus: false, isEnableCopy: false });
    }
  }
  dialogComponentContent = () => {
    return (
      <div className='container'>
        <div className='sub-container'>
          <div className='row mb-12'>
            <div className='col-md-2'>
              <TextBoxComponent
                placeholder='Template Code'
                cssClass='e-outline'
                floatLabelType='Auto'
                value={this.template_code}
                onChange={(e: any) => {
                  this.template_code = e.value;
                }}
              />
            </div>
            <div className='col-md-2'>
              <TextBoxComponent
                placeholder='Template Name'
                cssClass='e-outline'
                floatLabelType='Auto'
                value={this.name}
                onChange={(e: any) => {
                  this.name = e.value;
                }}
              />
            </div>

            <div className='col-md-2'>
              <DropDownListComponent
                id='ddlmoduleName'
                placeholder='Application Module'
                dataSource={this.state.component_data}
                fields={{ text: 'component_name', value: 'ID' }}
                cssClass='e-outline'
                floatLabelType='Auto'
                value={this.module_id}
                text={this.module_name}
                onChange={(e: any) => {
                  this.module_id = e.value;
                  this.module_name = e.target.typedString;
                }}
              />
            </div>
            <div className='col-md-2'>
              <DropDownListComponent
                id='ddlelementTabnamme'
                floatLabelType='Auto'
                value={this.state.tab_number}
                fields={{ value: 'value', text: 'name' }}
                dataSource={this.tabNameData}
                onChange={(e: any) => {
                  this.actionData = [];
                  this.tab_name = e.target.typedString;
                  this.setState({ tab_number: e.value, hideDialog: false });
                }}
                placeholder='Application Tab'
              />
            </div>
            <div
              className='col-md-2'
              style={{
                marginTop: 25,
              }}
            >
              <DropDownListComponent
                id='ddTeamPicker'
                dataSource={this.state.team_data}
                ref={(el: DropDownListComponent) => {
                  this.ddObj = el;
                }}
                onChange={(args: any) => {
                  this.team_value = args.value;
                  this.getTeamAssignment(this.team_value);
                }}
                placeholder='Select a Team'
                fields={{ text: 'team_code', value: 'team_id' }}
                value={this.team_value}
                width={'150px'}
              />
            </div>
            <div
              className='col-md-2'
              style={{
                marginTop: 25,
              }}
            >
              <DropDownListComponent
                id='userDDpicker'
                dataSource={this.state.user_data}
                ref={(el: DropDownListComponent) => {
                  this.ddObj = el;
                }}
                onChange={(args: any) => {
                  this.user_value = args.value;
                }}
                placeholder='Select a user'
                fields={{ text: 'name', value: 'user_id' }}
                value={this.user_value}
                width={'150px'}
              />
            </div>
          </div>
          <div className='template-sub-row2' style={{}}>
            <div className='template-sub-indesbut'>
              <div
                style={{
                  flexDirection: 'row',
                  display: 'flex',
                  padding: '10px',
                  // backgroundColor: this.context.isDarkMode
                  //   ? '#15202B'
                  //   : 'white',
                  color: 'white',
                  width: 50,
                }}
              >
                <button
                  onClick={this.increase.bind(this)}
                  disabled={this.state.plus}
                  style={{
                    border: 'none',
                    backgroundColor: this.context.isDarkMode
                      ? '#15202B'
                      : 'white',
                    color: 'white',
                  }}
                >
                  <IconContext.Provider
                    value={{
                      color: this.context.isDarkMode
                        ? this.state.plus
                          ? '#a39e9e'
                          : '#fcfafa'
                        : this.state.plus
                        ? '#a39e9e'
                        : '#686968',
                    }}
                  >
                    <FaPlus size={20} />
                  </IconContext.Provider>
                </button>
                <button
                  onClick={this.decrease.bind(this)}
                  disabled={this.state.minus}
                  style={{
                    border: 'none',
                    backgroundColor: this.context.isDarkMode
                      ? '#15202B'
                      : 'white',
                    color: 'white',
                  }}
                >
                  {' '}
                  <IconContext.Provider
                    value={{
                      color: this.context.isDarkMode
                        ? this.state.minus
                          ? '#a39e9e'
                          : '#fcfafa'
                        : this.state.minus
                        ? '#a39e9e'
                        : '#686968',
                    }}
                  >
                    <FaMinus size={20} />
                  </IconContext.Provider>
                </button>
              </div>
            </div>
            <div className='template-sub-2'>
              <div className='col-md-2'>
                <TextBoxComponent
                  placeholder='Row Count'
                  cssClass='e-outline'
                  floatLabelType='Auto'
                  type='number'
                  width={'200px'}
                  value={this.state.rowCount?.toString()}
                  change={this.Onchange.bind(this)}
                />
              </div>
              <div className='template-sub-switch'>
                <div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <span
                      style={{
                        marginRight: 5,
                      }}
                    >
                      Shared
                    </span>
                    <SwitchComponent
                      checked={this.isShare}
                      change={(args: any) => {
                        this.isShare = args.checked;
                      }}
                    />
                  </div>
                </div>
                <div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <span
                      style={{
                        marginRight: 5,
                      }}
                    >
                      Default
                    </span>
                    <SwitchComponent
                      checked={this.isDefault}
                      change={(args: any) => {
                        this.isDefault = args.checked;
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
        <div className='row mb-3 table-content'>
          <table
            id='dtVerticalScrollExample'
            className='table table-hover'
            style={{
              borderSpacing: '0 20px',
            }}
            cellSpacing={-10}
            width='80%'
          >
            <tbody>{this.state.dialogRowData}</tbody>
          </table>
        </div>
      </div>
    );
  };
  createdGrid() {
    getShiftWorkbenchTemplate().then((result) => {
      let filterData: any = result.data;
      if (this.props.isWorkbench) {
        var response = this.context.workbenchValueBottom.split(',');
        this.whereQuery = response[2];
        if (this.whereQuery === 'Equipment Summary') {
          this.is_equipment = true;
        } else {
          this.is_equipment = false;
        }
        if (this.whereQuery !== '') {
          filterData = result.data.filter(
            (x: any) => x.tab_name === this.whereQuery
          );
        }
      }
      if (this.grid.dataSource) {
        this.grid.dataSource = filterData;
      }
    });
    this.isItFirstTime = false;
  }
  public render() {
    return (
      <div>
        <GlobalGrid
          id='settings-workbench-template-grid'
          columns={wTemplateColumns}
          height={'calc(-290px + 100vh)'}
          query={''}
          toolbarOptions={this.toolbarOptions}
          get_query={'shift-workbench/workbench-template'}
          delete_query={'shift-workbench/workbench-template/delete'}
          signalOfLoad={true}
          gridRef={(ref: GridComponent) => (this.grid = ref)}
          toolbarClickItems={this.toolbarClick.bind(this)}
        />
        <div className='control-pane-dialog'>
          <div
            id='targetElement'
            className='col-lg-12 defaultDialog dialog-target'
          >
            {this.state.hideDialog ? (
              <DialogComponent
                isModal={true}
                id='defaultdialog'
                width={'1400px'}
                showCloseIcon={true}
                animationSettings={this.animationSettings}
                visible={this.state.hideDialog}
                header='Template'
                beforeClose={() => {
                  this.setState({ hideDialog: false });
                }}
                buttons={this.buttons}
                open={this.dialogOpen.bind(this)}
                close={this.dialogClose.bind(this)}
                content={this.dialogComponentContent.bind(this)}
              ></DialogComponent>
            ) : null}
            {this.state.hideDialogIsAdded ? (
              <DialogComponent
                isModal={true}
                id='defaultDialogIsAddedEquipment'
                showCloseIcon={true}
                beforeClose={() => {
                  this.setState({ hideDialogIsAdded: false });
                }}
                animationSettings={this.animationSettings}
                visible={this.state.hideDialogIsAdded}
                header='Confirmation'
                width={500}
                height={'auto'}
                buttons={this.buttonsIsAddedEquipment}
                open={() => {
                  this.setState({ hideDialogIsAdded: true });
                }}
                close={() => {
                  this.setState({ hideDialogIsAdded: false });
                }}
              >
                <div className='container'>
                  <div className='row'>
                    <span>
                      This template has already been added. Would you like to
                      add it again?
                    </span>
                  </div>
                </div>
              </DialogComponent>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}
